module.exports = "/_next/static/images/pizzatop-33e61d0baf05d5e1eebc47eacd0cb9d9.jpg";